import vuetify from '@/plugins/vuetify';
import { getModuleColors } from '@/config/moduleColors';

const THEME_NAME = 'sportipsTheme';

/** Style des titres (text-h*) lorsqu'un module définit `title_color` */
export const MODULE_TITLE_STYLE = {
  styleElementId: 'spo-module-title-color',
  cssVar: '--spo-title-color',
  selectors: '.text-h1, .text-h2, .text-h3, .text-h4, .text-h5, .text-h6',
};

const CSS_VAR_KEYS = {
  primary: '--spo-primary',
  primary_dark: '--spo-primary-dark',
  darkblue: '--spo-darkblue',
  text_color: '--spo-text-color',
  card_background: '--spo-light',
  card_background_hover: '--spo-light-hover',
  card_blue_grey: '--spo-blue-grey',
};

/** Clés Vuetify alignées sur la couleur de texte par défaut du module */
const VUETIFY_ON_TEXT_KEYS = ['on-background', 'on-white', 'on-grey_3', 'on-grey_4'];

function clearModuleTitleColor(root) {
  root.style.removeProperty(MODULE_TITLE_STYLE.cssVar);
  document.getElementById(MODULE_TITLE_STYLE.styleElementId)?.remove();
}

function applyModuleTitleColor(root, titleColor) {
  clearModuleTitleColor(root);
  if (!titleColor) {
    return;
  }

  root.style.setProperty(MODULE_TITLE_STYLE.cssVar, titleColor);

  const style = document.createElement('style');
  style.id = MODULE_TITLE_STYLE.styleElementId;
  style.textContent = `${MODULE_TITLE_STYLE.selectors} {
  color: var(${MODULE_TITLE_STYLE.cssVar}) !important;
}`;
  document.head.appendChild(style);
}

/**
 * Applique primary, primary_dark et darkblue au thème Vuetify
 * et aux variables CSS utilisées par les feuilles SCSS.
 *
 * @param {string} baseModule - Trigramme du module (route ou module.base)
 * @param {Record<string, string>} [dbPersonalization] - Surcharges depuis nm_module_personalization
 */
export function applyModuleTheme(baseModule, dbPersonalization = {}) {
  const colors = getModuleColors(baseModule, dbPersonalization);
  const theme = vuetify.theme.themes.value[THEME_NAME];
  const root = document.documentElement;

  if (theme?.colors) {
    theme.colors.primary = colors.primary;
    theme.colors['primary-dark'] = colors.primary_dark;
    theme.colors.darkblue = colors.darkblue;
    theme.colors.dark = colors.darkblue;
    VUETIFY_ON_TEXT_KEYS.forEach((key) => {
      theme.colors[key] = colors.text_color;
    });
  }

  Object.entries(CSS_VAR_KEYS).forEach(([key, cssVar]) => {
    root.style.setProperty(cssVar, colors[key]);
  });

  applyModuleTitleColor(root, colors.title_color);
}
